export function csrfToken(): string {
  return document.cookie.split('; ').find((item) => item.startsWith('training_csrf='))?.split('=')[1] ?? '';
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  if (!['GET', 'HEAD'].includes((options.method ?? 'GET').toUpperCase())) headers.set('x-csrf-token', csrfToken());
  const response = await fetch(path, { ...options, headers, credentials: 'same-origin' });
  const contentType = response.headers.get('content-type') ?? '';
  const body = contentType.includes('application/json') ? await response.json() as { error?: string } : await response.text();
  if (!response.ok) throw new Error(typeof body === 'object' && body?.error ? body.error : `Ошибка сервера: ${response.status}`);
  return body as T;
}

export function downloadUrl(path: string): void {
  const anchor = document.createElement('a');
  anchor.href = path;
  anchor.download = '';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}
